// src/pages/personal/platforms/BroadcastsPage.tsx
 
 import React from 'react';
 import { AdaptiveLayout } from '@/components/ui/Layout';
 import BroadcastsSection from './BroadcastsSection/BroadcastsSection';

 const BroadcastsPage: React.FC = () => {
   return (
     <AdaptiveLayout>
       <BroadcastsSection />
     </AdaptiveLayout>
   );
 };

export default BroadcastsPage;